<template>
  <QBtn
    :href="link"
    target="_blank"
    rel="noopener noreferrer"
    class="tw-w-full tw-min-w-24 hover:-tw-translate-y-1 tw-duration-500 !tw-transition tw-rounded-lg"
    :outline="outline"
    :class="[variantClasses, buttonClass]"
    unelevated
    no-caps
    @click="emit('click')"
  >
    <QIcon
      v-if="icon"
      :name="icon"
      :class="iconClass"
      :style="
        iconSize !== 'xs' ? { width: iconSize, height: iconSize } : undefined
      "
    />
    <span :class="titleClass" class="tw-whitespace-nowrap">
      {{ title }}
    </span>
  </QBtn>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title: string;
    link: string;
    icon?: string;
    variant?: ButtonVariant;
    outline?: boolean;
    titleClass?: string;
    buttonClass?: string;
    iconSize?: string;
    iconClass?: string;
  }>(),
  {
    variant: "primary",
    icon: "",
    outline: false,
    titleClass: "tw-text-mb-button lg:tw-text-dt-button",
    buttonClass: "",
    iconSize: "xs",
    iconClass: "tw-mr-2",
  },
);

const variantClasses = computed(() => {
  const baseClasses = "tw-transition-colors tw-duration-300";

  switch (props.variant) {
    case "whatsapp":
      return props.outline
        ? `${baseClasses} tw-text-whatsapp tw-border-whatsapp`
        : `${baseClasses} tw-bg-whatsapp tw-text-white`;
    case "facebook":
      return props.outline
        ? `${baseClasses} tw-text-facebook tw-border-facebook`
        : `${baseClasses} tw-bg-facebook tw-text-white`;
    case "line":
      return props.outline
        ? `${baseClasses} tw-text-line tw-border-line`
        : `${baseClasses} tw-bg-line tw-text-white`;
    default:
      return props.outline
        ? `${baseClasses} tw-text-primary tw-border-primary`
        : `${baseClasses} tw-bg-primary tw-text-white`;
  }
});

const emit = defineEmits(["click"]);
</script>

<style lang="scss" scoped>
:deep(.q-btn) {
  @apply tw-min-h-[48px] tw-rounded-md;
}
</style>
